// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".dialog[data-v-4955cae3]{max-width:550px;min-height:280px}.dialog__message[data-v-4955cae3]{color:#000!important;white-space:pre-wrap}.dialog__message[data-v-4955cae3],.dialog__title[data-v-4955cae3]{text-align:left;font:normal normal 700 24px/32px Segoe UI;letter-spacing:0;opacity:1}", ""]);
// Exports
module.exports = exports;
